export const PrismicRepositoryType = {
  BUSINESS: 'business',
  TECHNICAL: 'technical',
};
